/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
import { Dictionary } from 'vue-router/types/router';
import { Store } from 'vuex';

import {
  EAtrybutyMulti,
  EAtrybutySingle,
  EOtherAttributes,
  ISzukajPayload,
  IAtrybutyMulti,
  IAtrybutySingle,
  keysMap,
} from '@/types/ISzukajPayload';
import { ETransportValue } from '~/components/filtry/types/ETransportValue';
import { upperCaseKeys } from '~/helper-functions/store/upperCaseKeys';

const queryString = require('query-string');

const checkOldParams = (query: Dictionary<string | (string | null)[]>) => {
  for (const [key] of Object.entries(query)) {
    if (key.includes('[]')) {
      return false;
    }
  }
  return true;
};

const convertNamesParams = (
  unknownParam: any,
  filtry: { [key: string]: ISzukajPayload },
  atrybutyMulti: { [key: string]: IAtrybutyMulti },
  atrybutySingle: { [key: string]: IAtrybutySingle },
) => {
  for (const [key, element] of Object.entries(unknownParam)) {
    for (const [oldKey, newKey] of Object.entries(keysMap)) {
      if (key === oldKey) {
        unknownParam[newKey] = element;
        delete unknownParam[key];
      }
    }
    // typyTransportu=air&typyTransportu=bus&typyTransportu=air-bezposrednio&typyTransportu=dreamliner&typyTransportu=self
    // typy transportu nie sie zgadzaja wartosci
    // if (key == 'typyTransportu') {
    //     console.log('if typyTransportu', key, element)
    // }
    if (key === 'dataOd') {
      const dataDo = Object.prototype.hasOwnProperty.call(unknownParam, 'dataDo');

      dataDo ? (unknownParam.terminWyjazdu = [element, unknownParam.dataDo]) : (unknownParam.terminWyjazdu = [element]);
      if (dataDo) {
        delete unknownParam.dataDo;
      }

      delete unknownParam[key];
    }
  }

  for (const [key, element] of Object.entries(unknownParam)) {
    if (key in EOtherAttributes) {
      key === 'datyUrodzenia' && typeof element === 'string'
        ? (filtry[key] = [element] as ISzukajPayload)
        : (filtry[key] = element as ISzukajPayload);
      continue;
    }

    if (key in EAtrybutyMulti) {
      typeof element === 'string' ? (atrybutyMulti[key] = [element] as IAtrybutyMulti) : (atrybutyMulti[key] = element as IAtrybutyMulti);
      continue;
    }

    if (key in EAtrybutySingle) {
      typeof element === 'string'
        ? (atrybutySingle[key] = [element] as IAtrybutySingle)
        : (atrybutySingle[key] = element as IAtrybutySingle);
      continue;
    }
  }
  // console.log("🚀 convertNamesParams", unknownParam, filtry, atrybutyMulti, atrybutySingle)
  // Todo: typyWycieczek, iatyWyjazdu, miastaWyjazdu
  // zczytywane dlugosc pobytu, promocje, sezon, tematyka, wiek, liczbaPokoi, wyzywienie, panstwa, regiony, miastaWyjazdu
  // ignorowane czyCenaZaWszystkich, hotel, sortuj=CenaAsc, grupujTerminy, czyPotwierdzoneTerminy, pokazywaneLotniska, udogodnienia, ocenaMin=4.5&ocenaMax roznia sie wartosci, standardHoteluMin=5&standardHoteluMax=5 roznia sie wartosci
};

const parseParamsFromUrl = (params: Dictionary<string | (string | null)[]>, store: Store<unknown>) => {
  const paramsStringify = queryString.stringify(params);
  const oldParams = checkOldParams(params);
  const queryStringParse = oldParams ? queryString.parse(paramsStringify) : queryString.parse(paramsStringify, { arrayFormat: 'bracket' });

  const filtry = {} as { [key: string]: ISzukajPayload };
  const atrybutyMulti = {} as { [key: string]: IAtrybutyMulti };
  const atrybutySingle = {} as { [key: string]: IAtrybutySingle };
  const unknownParam = {} as any;

  for (const [key, element] of Object.entries(queryStringParse)) {
    if (key in EOtherAttributes) {
      if (key === EOtherAttributes.sortowanie.toLowerCase() && element === 'termin-asc') {
        store.commit('szukaj/userIntrestedInTerminAsc', true);
      }

      if (key === EOtherAttributes.widok) {
        filtry[key] = element === 'list' ? ('bloczki' as ISzukajPayload) : ('map' as ISzukajPayload);
        continue;
      }

      if (key === EOtherAttributes.liczbaPokoi) {
        if (element === null) {
          filtry.dowolnaLiczbaPokoi = 'tak' as ISzukajPayload;
        } else {
          filtry.dowolnaLiczbaPokoi = 'nie' as ISzukajPayload;
        }
      }

      filtry[key] = element as ISzukajPayload;
      continue;
    }

    if (key === 'wybraneDokad') {
      if (!atrybutyMulti.Lokalizacje_HoteloProdukt) {
        atrybutyMulti.Lokalizacje_HoteloProdukt = [] as IAtrybutyMulti;
      }

      typeof element === 'string'
        ? (atrybutyMulti.Lokalizacje_HoteloProdukt as Array<string>).push(element)
        : (atrybutyMulti.Lokalizacje_HoteloProdukt as Array<string>).push(...(element as Array<string>));
      continue;
    }

    if (key === 'wybraneHoteloProdukty') {
      if (!atrybutyMulti.Lokalizacje_HoteloProdukt) {
        atrybutyMulti.Lokalizacje_HoteloProdukt = [] as IAtrybutyMulti;
      }

      typeof element === 'string'
        ? (atrybutyMulti.Lokalizacje_HoteloProdukt as Array<string>).push(element)
        : (atrybutyMulti.Lokalizacje_HoteloProdukt as Array<string>).push(...(element as Array<string>));
      continue;
    }

    if (key === 'wybraneSkad') {
      if (typeof element === 'string') {
        const strings = element.split(',');

        atrybutyMulti.Miasta = [...strings] as IAtrybutyMulti;
      } else {
        const helpArray: string[] = [];

        (element as Array<string>).forEach((value) => {
          const strings = value.split(',');

          helpArray.push(...strings);
        });
        atrybutyMulti.Miasta = helpArray as IAtrybutyMulti;
      }

      continue;
    }

    if (key in EAtrybutyMulti) {
      oldParams && typeof element === 'string'
        ? (atrybutyMulti[key] = [element] as IAtrybutyMulti)
        : (atrybutyMulti[key] = element as IAtrybutyMulti);
      continue;
    }

    if (key in EAtrybutySingle) {
      if (key === EAtrybutySingle.typTransportu) {
        if (typeof element === 'object' && (element as string[]).length > 1) {
          atrybutySingle[key] = element as IAtrybutySingle;
        } else {
          if (element === ETransportValue.air) {
            atrybutySingle[key] = [ETransportValue.air, ETransportValue.dreamliner] as IAtrybutySingle;
          }

          atrybutySingle[key] = [element] as IAtrybutySingle;
        }

        continue;
      }

      oldParams ? (atrybutySingle[key] = [element] as IAtrybutySingle) : (atrybutySingle[key] = element as IAtrybutySingle);
      continue;
    } else {
      unknownParam[key] = element;
    }
  }

  if (oldParams) convertNamesParams(unknownParam, filtry, atrybutyMulti, atrybutySingle);

  // @@@@@@@@@

  const DatyUrodzenia: string[] = typeof unknownParam.dorosli === 'string' ? [unknownParam.dorosli] : unknownParam.dorosli;

  if (!(unknownParam.dzieci === 'nie') && DatyUrodzenia) {
    typeof unknownParam.dzieci === 'string' ? DatyUrodzenia.push(unknownParam.dzieci) : DatyUrodzenia.push(...unknownParam.dzieci);
  }

  const filtr = upperCaseKeys(filtry);

  atrybutySingle.TerminWyjazdu = unknownParam.data as IAtrybutySingle;
  const cenaFromNuxt3 = [unknownParam.Cena];

  if (unknownParam['cena.od'] || unknownParam['cena.do']) {
    cenaFromNuxt3.push(`${unknownParam['cena.od']}-${unknownParam['cena.do']}`);
  }

  atrybutySingle.Cena = cenaFromNuxt3 as IAtrybutySingle;

  const dlugoscPobytuFromNuxt3 = [unknownParam.DlugoscPobytu];

  if (unknownParam['dlugoscPobytu.od'] || unknownParam['dlugoscPobytu.do']) {
    dlugoscPobytuFromNuxt3.push(`${unknownParam['dlugoscPobytu.od']}-${unknownParam['dlugoscPobytu.do']}`);
  }

  atrybutySingle.DlugoscPobytu = dlugoscPobytuFromNuxt3 as IAtrybutySingle;

  filtr.DatyUrodzenia = DatyUrodzenia as ISzukajPayload;

  // @@@@@@@@@
  filtr.AtrybutyMulti = upperCaseKeys(atrybutyMulti);
  filtr.AtrybutySingle = upperCaseKeys(atrybutySingle);
  store.commit('szukaj/paramsUrl', filtr);
};

export default parseParamsFromUrl;
